import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { createRoom, selectRoom } from 'nm-react-chat'; 

import { getUnreadMessageFromJournalist } from './../../../user/userActions';

import firebaseApp from './../../../../utils/firebase/firebase';

import { showComment, showBlockedCommentPopup } from './../../../Article/articleActions';
import { showBlockedChatPopup } from './../../../Editions/editionsActions';
import Aux from './../../../../hoc/_Aux';

export class ChatroomButton extends Component {

    extractMessagesData = (timestamps, messages) => {
        let hasUnreadJournalistMessage = false;

        if(typeof messages === 'undefined'){
            return hasUnreadJournalistMessage;
        }

        for(var messageId in messages) {
            if(messages[messageId].createdAt > timestamps){
                hasUnreadJournalistMessage = true;
            }
        }

        return hasUnreadJournalistMessage;
    }

    onBlockedCommentClickHandler = () => {
        const { dispatch } = this.props;
        dispatch(showBlockedCommentPopup());
    }

    onBlockedChatClickHandler = () => {
        const { dispatch } = this.props;
        dispatch(showBlockedChatPopup());
    }

    onClickHandler = () => {
        const { roomName, metaData, comment, dispatch } = this.props;

        firebaseApp.database().ref(`rooms/`)
            .orderByChild('roomName')
            .equalTo(roomName)
            .once('value')
            .then(function(snapshot){
                if(snapshot.val() !== null)
                {
                    const key = Object.keys(snapshot.val())[0];
                    dispatch(selectRoom(key, roomName));
                }
                else {
                    dispatch(createRoom(roomName, metaData, true));
                }
                if(comment)
                {
                    dispatch(showComment());
                }
                else {
                    dispatch(push("/chat-with-journalist"));
                }
                
            })
            .catch((err) => {console.error('ChatroomButton : ', err)}); 
    }

    componentDidMount() {
        const {roomName, dispatch, isUserSignedIn} = this.props;
        
        if(isUserSignedIn && roomName.toString().substring(roomName.length-4) === '_ask')
        {
            firebaseApp.database().ref(`rooms/`)
            .orderByChild('roomName')
            .equalTo(roomName)
            .once('value')
            .then((snapshot) => {
                if(snapshot.val() !== null)
                {
                    const idRoom = Object.keys(snapshot.val())[0];
                    const { messages, lastSeen } = snapshot.val()[idRoom];
                    const userLastSeen = lastSeen[firebaseApp.auth().currentUser.uid] || 0;
                    dispatch(getUnreadMessageFromJournalist(this.extractMessagesData(userLastSeen, messages)));

                    firebaseApp.database().ref('rooms/' + idRoom).on('child_changed', (snapshot) => {
                        const updatedChild = Object.values(snapshot.val());
                        //if a child own the property message then it's a message (it could also be the lastSeen property that could be changed)
                        if(updatedChild[0].hasOwnProperty('message')){
                            if(updatedChild[updatedChild.length-1].uid !== firebaseApp.auth().currentUser.uid)
                            {
                                dispatch(getUnreadMessageFromJournalist(true));
                            }
                        }
                    });
                }
            });
        }

    }

    componentWillUnmount(){
        const ref = firebaseApp.database().ref('rooms');
        ref.off('child_changed')
        
    }

    render(){
        const { hasUnreadJournalistMessage, isUserSignedIn } = this.props;
        let buttonOutput = null;
        if(this.props.comment===true){
            //this button is deactivated for the beta, we have to uncomment to have access
            buttonOutput = (<span onClick={this.onClickHandler} className="comment-button" />);
            //buttonOutput = (<span onClick={this.onBlockedCommentClickHandler} className="comment-button" />);
        }else{
            //chat journalist button
            buttonOutput = (<span onClick={isUserSignedIn?this.onClickHandler:this.onBlockedChatClickHandler} className={`chat-journalist-button${hasUnreadJournalistMessage?' notif':''}`}></span>);
        }

        return(
            <Aux>
               {buttonOutput} 
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hasUnreadJournalistMessage: state.user.hasUnreadJournalistMessage,
        isUserSignedIn: state.auth.isUserSignedIn
    };
}

export default connect(mapStateToProps)(ChatroomButton);





// WEBPACK FOOTER //
// ./src/components/UI/Common/ChatButton/ChatButton.js